import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import '../styles/productLanguageModal.css';

import enFlag from "../../../assets/english.svg";
import arFlag from "../../../assets/arabic.svg";


const languages = [
  { code: 'en', name: 'English', flag: enFlag },
  { code: 'ar', name: 'Arabic', flag: arFlag }
];

function ProductLanguageModal({ show, onHide, onSelect }) {
  const [selectedLanguage, setSelectedLanguage] = useState('');

  const handleSelect = () => {
    if (selectedLanguage) {
      onSelect(selectedLanguage);
      onHide();
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered className="product-language-modal">
      <Modal.Body>
        <h2 className="modal-title">Choose Language?</h2>
        <div className="language-options">
          {languages.map((language) => (
            <button
              key={language.code}
              className={`language-option ${selectedLanguage === language.code ? 'selected' : ''}`}
              onClick={() => setSelectedLanguage(language.code)}
            >
              <img src={language.flag} alt={`${language.name} flag`} className="language-flag" />
              <span className={language.code === selectedLanguage ? 'text-orange' : ''}>{language.name}</span>
            </button>
          ))}
        </div>
        <Button
          className="select-button"
          onClick={handleSelect}
          disabled={!selectedLanguage}
        >
          Select
        </Button>
      </Modal.Body>
    </Modal>
  );
}

export default ProductLanguageModal;